"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M16.5 18.0002H3.533C3.239 18.0002 3 17.7612 3 17.4672V16.5332C3 16.2393 3.239 16.0002 3.533 16.0002H16.467C16.761 16.0002 17 16.2393 17 16.5332V17.5002C17 17.7762 16.776 18.0002 16.5 18.0002ZM14.2627 5.86595C14.0667 6.05595 13.7537 6.05295 13.5607 5.85995L11.5147 3.81495C11.3137 3.61295 11.3217 3.28295 11.5327 3.09195L12.4427 2.26395C12.8437 1.89895 13.4607 1.91395 13.8437 2.29995L15.1307 3.59295C15.5297 3.99395 15.5237 4.64295 15.1167 5.03695L14.2627 5.86595ZM10.7305 4.46465L12.8215 6.55565C13.0185 6.75365 13.0155 7.07365 12.8155 7.26865L6.3385 13.5156C6.1495 13.6976 5.8975 13.7996 5.6345 13.7996H3.2505C3.1125 13.7996 3.0005 13.6886 3.0005 13.5496V11.2086C3.0005 10.9216 3.1225 10.6467 3.3355 10.4546L10.0405 4.44865C10.2375 4.26865 10.5415 4.27565 10.7305 4.46465Z",
    fill: "#727B7F"
  }));
};